import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check, Sparkles } from "lucide-react";
import { Reveal, PlatformBadge } from "@/components/marketing/kit";
import { CASES } from "@/components/marketing/content";

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const c = CASES.find((x) => x.slug === slug);
  if (!c) return (
    <main><section className="mk-sec"><div className="mk-wrap mk-head">
      <h1 className="mk-h2">Case study not found</h1>
      <Link to="/case-studies" className="mk-btn ghost" style={{ margin: "20px auto 0", width: "max-content" }}>Back to case studies</Link>
    </div></section></main>
  );
  return (
    <main><section className="mk-sec"><div className="mk-wrap">
      <div className="mk-case-detail">
        <Link to="/case-studies" className="back" data-testid="case-back"><ArrowLeft size={15} /> All case studies</Link>
        <Reveal><div className="mk-case-hero">
          <img src={`${c.cover}&w=1100`} alt={c.brand} /><div className="ov" />
          <div className="cap">
            <PlatformBadge platform={c.platform} />
            <h1 style={{ marginTop: 12 }} data-testid="case-detail-title">{c.headline}</h1>
            <p style={{ color: "var(--tx2)", marginTop: 8 }}>{c.brand} · {c.industry}</p>
          </div>
        </div></Reveal>

        <div className="mk-case-resultgrid" data-testid="case-results">
          {c.results.map(([v, l]) => <div key={l}><b>{v}</b><small>{l}</small></div>)}
        </div>

        <h2>The challenge</h2>
        <p>{c.challenge}</p>

        <h2>The approach</h2>
        <ul>{c.approach.map((a) => <li key={a}><Check size={18} /> {a}</li>)}</ul>

        <div className="mk-case-quote" data-testid="case-quote">
          "{c.quote}"<span>— {c.person}</span>
        </div>

        <div className="mk-cta" style={{ marginTop: 20 }}>
          <span className="mk-pill" style={{ margin: "0 auto" }}><Sparkles size={14} /> Ready to replicate this?</span>
          <h2 style={{ fontSize: "clamp(26px,3.5vw,42px)" }}>Run a campaign like {c.brand}'s</h2>
          <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="case-detail-trial">Start free <ArrowRight size={17} /></Link><Link to="/creators" className="mk-btn ghost lg">Browse creators</Link></div>
        </div>
      </div>
    </div></section></main>
  );
}
